import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import { getStore } from 'owa-mail-store/lib/store/Store';
import Item from 'owa-service/lib/contract/Item';

export const isSharedItemForRead = (item: Item) => (): boolean => {
    return isSharedItem(item);
};

export const isSharedItemForCompose = (viewState: ComposeViewState) => (): boolean => {
    if (!viewState.itemId) {
        return false;
    }

    const item = getStore().items.get(viewState.itemId.Id);
    return isSharedItem(item);
};

function isSharedItem(item: Item) {
    if (!item || !item.ParentFolderId) {
        return false;
    }

    const folderId = item.ParentFolderId.Id;
    return isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE);
}
